import * as actionTypes from '../constants/action-types';

export const initializeAction = () => ({
  type: actionTypes.INITIALIZE,
});
